import React from 'react';
import { CautionIcon } from '@eds/icon';

type Props = {
  size?: 'small' | 'xsmall' | 'medium' | 'large';
};

export const DeprecationIcon = ({ size = 'small' }: Props) => <CautionIcon color="caution" size={size} />;
